<template>
    <div>
      <DxPopup
        ref="popupAccount"
        :width="650"
        :height="heightPopup"
        :visible="open"
        :show-title="false"
        :hide-on-outside-click="true"
        :loadPanel="load"
        :show-close-button="true"
        :resize-enabled="true"
        @hidden="onHidden"
      >
        <DxScrollView width="100%" height="100%">
          <form @submit="handleSubmit">
          <DxForm
            :ref="reformUser"
            v-model:form-data="data_user"
            :show-colon-after-label="true"
            :show-validation-summary="true"
            :read-only="false"
            :col-count-by-screen="colCountByScreen"
            :screen-by-width="screenByWidth"
            :min-col-width="233"
            label-location="top"
            :col-count="1"
          >
            <DxGroupItem caption="Información del Usuario" :col-count="2">
              <DxSimpleItem data-field="first_name" :editor-options="{ disabled: false }">
                  <DxLabel text="Nombres:" />
                  <DxRequiredRule message="Los nombres son requeridos"/>
              </DxSimpleItem>
              <DxSimpleItem data-field="last_name" :editor-options="{ disabled: false }">
                  <DxLabel text="Apellidos:" />
                  <DxRequiredRule message="Los apellidos son requeridos"/>
              </DxSimpleItem>
              <DxSimpleItem data-field="email" :editor-options="{ disabled: true }">
                  <DxLabel text="Correo" />
              </DxSimpleItem>
              <DxSimpleItem data-field="phone" :editor-options="{ disabled: false }">
                  <DxLabel text="Teléfono" />
              </DxSimpleItem>
              <DxSimpleItem data-field="mobile" :editor-options="{ disabled: false }">
                  <DxLabel text="Celular" />
              </DxSimpleItem>
              <DxSimpleItem data-field="university" :editor-options="{ disabled: false }">
                  <DxLabel text="Universidad" />
              </DxSimpleItem>
              <DxSimpleItem data-field="position" :editor-options="{ disabled: false }">
                  <DxLabel text="Cargo" />
              </DxSimpleItem>
              <DxSimpleItem data-field="address" :editor-options="{ disabled: false }">
                  <DxLabel text="Dirección" />
              </DxSimpleItem>
              <DxSimpleItem data-field="country" :editor-options="{ disabled: false }">
                  <DxLabel text="País" />
              </DxSimpleItem>
              <DxSimpleItem data-field="state" :editor-options="{ disabled: false }">
                  <DxLabel text="Departamento" />
              </DxSimpleItem>
              <DxSimpleItem data-field="town" :editor-options="{ disabled: false }">
                  <DxLabel text="Ciudad" />
              </DxSimpleItem>
              <DxSimpleItem data-field="zip_code" :editor-options="{ disabled: false }">
                  <DxLabel text="Código Postal" />
              </DxSimpleItem>
              <DxSimpleItem
                :editor-options="languageEditorOptions"
                data-field="language"
                editor-type="dxSelectBox"
              >
                <DxLabel text="Idioma" />
                <DxRequiredRule message="El idioma es requerido"/>
              </DxSimpleItem>
            </DxGroupItem>
          </DxForm>
          </form>
        </DxScrollView>
        <dx-toolbar-item
          widget="dxButton"
          :options="btnSave"
          location="after"
          toolbar="bottom"
        >
        </dx-toolbar-item>
        <dx-toolbar-item
          widget="dxButton"
          :options="btnCancel"
          location="after"
          toolbar="bottom"
        >
        </dx-toolbar-item>
      </DxPopup>
    </div>
  </template>
  <script>
  /* eslint-disable */
  import DxForm, {
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxButtonOptions,
    DxLabel,
    DxRequiredRule,
    DxCompareRule,
  } from "devextreme-vue/form";
  import DxPopup, { DxToolbarItem } from "devextreme-vue/popup";
  import { DxScrollView } from "devextreme-vue/scroll-view";
  import ArrayStore from "devextreme/data/array_store";
  import notify from "devextreme/ui/notify";
  import http from "../../api/http";
  import auth from "@/auth";
  var ui = require("../../plugins/busyUi").default;
  var _this = null; 
  export default {
    components: {
      DxGroupItem,
      DxSimpleItem,
      DxButtonItem,
      DxLabel,
      DxRequiredRule,
      DxCompareRule,
      DxForm,
      DxPopup,
      DxScrollView,
      DxToolbarItem,
      DxButtonOptions,
    },
    computed: {
      colCountByScreen() {
        return null;
      },
    },
    props: {
      open: {
        default: false,
        type: Boolean,
      },
    },
    watch: {
      async open(n) {
        let _this=this;
        if (n) {
          ui.busyUi(true, $(_this.insPopup._$element[0]));
          await http
          .get("user/"+auth.get_user_id(), {})
          .then((response) => {
            _this.data_user.first_name=response.DATA.first_name;
            _this.data_user.last_name=response.DATA.last_name;
            _this.data_user.email=response.DATA.email;
            _this.data_user.phone=response.DATA.telephone;
            _this.data_user.mobile=response.DATA.mobile;
            _this.data_user.university=response.DATA.university;
            _this.data_user.position=response.DATA.position;
            _this.data_user.address=response.DATA.address;
            _this.data_user.country=response.DATA.country;
            _this.data_user.state=response.DATA.state;
            _this.data_user.town=response.DATA.town;
            _this.data_user.zip_code=response.DATA.zip_code;  
            _this.data_user.language=parseInt(response.DATA.language_id);
          })
          .catch((error) => {
            ui.busyUi(false, $(_this.insPopup._$element[0]));
            console.error("Error de conexión", error);
          });
          ui.busyUi(false, $(_this.insPopup._$element[0]));
          this.insForm.option("formData", this.data_user);
        }
      },
    },
    data() {
      return {
        reformUser: "formUserData",
        heightPopup: "90vh",
        data_user: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          mobile: '',
          university: '',
          position: '',
          address: '',
          country: '',
          state: '',
          town: '',
          zip_code: '',
          language: 1,
        },
        btnSave: {
          //icon: "fas fa-floppy-disk",
          text: "Salvar",
          //type: 'success',
          useSubmitBehavior: true,
          onClick: function () {
            
            ui.busyUi(true, $(_this.insPopup._$element[0]));
            http
            .put("user_update/" + auth.get_user_id(),_this.data_user)
            .then((response) => {
              ui.busyUi(false, $(_this.insPopup._$element[0]));
              if(response.STATUS_CODE!=1){
                  notify(
                  {
                    message: response.DATA,
                    width: "auto",
                    shading: false,
                    position: { at: "center" },
                  },
                  "error",
                  2000
                );
              }
              else {
                notify({
                  message: 'Se han actualizado los datos de usuario satisfactoriamente',
                  position: {
                    my: 'center top',
                    at: 'center top',
                  },
                }, 'success', 3000);
              }
              _this.insPopup.hide();
            })
            .catch((error) => {
              console.error("Error de conexión", error);
              ui.busyUi(false, $(_this.insPopup._$element[0]));
            });
          },
        },
        btnCancel: {
          //icon: "fas fa-window-close",
          text: "Cancelar",
          onClick: function () {
            _this.insPopup.hide()
          },
        },
        load: {
          enabled: true,
        },
        passwordOptions: {
          mode: "password",
        },
        languageEditorOptions: {
          valueExpr: "id",
          displayExpr: "name",
          dataSource: new ArrayStore({
            data: [{id:1,name:'Español'},{id:2,name:'Ingles'},{id:3,name:'Portugues'}],
            key: "id",
          }),
        },
      };
    },
    methods: {
      onHidden() {
        this.$event.emit("closeSettingUser");
      },
      passwordComparison() {
        return this.data_user.Password;
      },
      screenByWidth(width) {
        return width < 720 ? "sm" : "md";
      },
      isEqual(str1, str2)
      {
          return str1.toUpperCase() === str2.toUpperCase()
      }
    },
    mounted() {
      var ref = this.reformUser;
      _this = this;
      this.insForm = this.$refs[ref] && this.$refs[ref].instance;
      this.insPopup = this.$refs["popupAccount"] && this.$refs["popupAccount"].instance; 
    },
  };
  </script>
  